import * as React from 'react';
import { connect } from 'react-redux';
import { IStateApp } from '../../Reducers';
import { createActionFetchFaenas } from '../../Actions/Session/Actions';
import { ISessionState } from '../../Reducers/Session';
import Box from '../../Components/Box';
import { Producer, Summary, StageProducer, ShipmentSummary } from '../../Models/Report';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Skeleton from 'antd/lib/skeleton';
import PieChart from '../../Components/PieChart';
import Popper from '../../Components/Popper';
import PopperTitle from '../../Components/PopperTitle';
import './Home.scss';
import CardSummaryStage from '../../Components/CardSummaryStage';
import Download from '../../Components/Download';
import CardSummaryAnnual from '../../Components/CardSummaryAnnual';
import { createActionFetchSummary, createActionClearData, EReport } from '../../Actions/Report/Actions';

export interface IHomeProps extends ISessionState {
	onFaenas: (id: number) => void;
	loadingDashboard: boolean;
	producers: Producer[];
	stageProducer: StageProducer[];
	shipmment: ShipmentSummary;
	onShipment: (id: number, idProducer: string, idBranch: number) => void;
	requestShipment: boolean;
	clearShipment: () => void;
}

class Home extends React.Component<IHomeProps> {
	componentWillMount() {
		if (this.props.account) {
			const id = this.props.account.id;
			this.props.onFaenas(id);
		}
	}

	render() {
		return <div className="Home">
				<h1>Resumen Cobre en Puerto Angamos</h1>
				{this.props.producers.length > 0 && <Download producers={this.props.producers} idUser={this.props.account!.id} />}
				<Box loading={this.props.loadingDashboard}>
					<Row>
						<Col span={13}>
							<div className="Home-graph">
								<h2>Cobre en Puerto Angamos por Empresa/Faena</h2>
								<Skeleton active paragraph={{ rows: 10 }} loading={this.props.loadingDashboard || this.props.producers.length === 0 || this.props.producers.map(p => p.loading).reduce((a, c) => c || a)} >
									<PieChart loading={this.props.loadingDashboard} data={this.props.producers.map(p => ({ name: p.name, total: p.summary.total, color: p.color }) as Summary)} />
								</Skeleton >
							</div>
						</Col>
						<Col span={11}>
							<PopperTitle />
							{this.getProducers().map(p => <Popper key={`producer-title-${p.id}`} producer={p} />)}
						</Col>
					</Row>
				</Box>
				<CardSummaryStage producersStage={this.props.stageProducer} />
				<CardSummaryAnnual request={this.props.requestShipment} onSummary={this.getSummary.bind(this)} producers={this.props.producers} shipmentData={this.props.shipmment} />
			</div>;
	}

	private getSummary(idProducer: string, idBranch: number) {
		if (this.props.account) {
			this.props.onShipment(this.props.account.id, idProducer, idBranch);
		}
	}
	componentWillUnmount() {
		this.props.clearShipment();
	}
	private getProducers() {
		return this.props.producers.sort((a: Producer, b: Producer) => {
			if (a.summary.total > b.summary.total) {
				return -1;
			}
			if (b.summary.total > a.summary.total) {
				return 1;
			}
			return 0;
		});
	}
}

const mapProps = (state: IStateApp) => ({
	...state.session,
	loadingDashboard: state.report.isRequestDashboard,
	producers: state.report.producers,
	stageProducer: state.report.stageProducer,
	shipmment: state.report.shipmentSummary,
	requestShipment: state.report.isRequestShipment
})
const mapActions = (dispatch: any) => {
	return {
		onFaenas: (id: number) => dispatch(createActionFetchFaenas(id)),
		onShipment: (id: number, idProducer: string, idBranch: number) => dispatch(createActionFetchSummary(id, idProducer, idBranch)),
		clearShipment: () => dispatch(createActionClearData(EReport.Summary))
	}
}

export default connect<IHomeProps>(mapProps as any, mapActions)(Home) as any;
